import { getPagePostsQuery } from '@redlink/services';

export const freshCacheForVisibility = ({ category, pageIndex, pageSize }) => (
  cache,
  { data: { SetLinkIsVisible: { id, isVisible } = {} } }
) => {
  freshPostsVisibility({
    cache,
    isVisible,
    id,
    category,
    pageIndex,
    pageSize,
  });
};

const freshPostsVisibility = ({
  cache,
  isVisible,
  id,
  category,
  pageIndex,
  pageSize,
}) => {
  let {
    Posts: { totalCount, items: oldData },
  } = cache.readQuery({
    query: getPagePostsQuery,
    variables: {
      ...(category && { category: category?.item?.id }),
      skip: pageIndex * pageSize,
      take: pageSize,
    },
  });

  let freshData = { ...oldData.find((p) => p.id === id), isVisible };

  cache.writeQuery({
    query: getPagePostsQuery,
    data: {
      Posts: {
        totalCount,
        items: getFreshPosts({ id, oldData, freshData }),
      },
    },
    variables: {
      ...(category && { category: category?.item?.id }),
      skip: pageIndex * pageSize,
      take: pageSize,
    },
  });
};

const getFreshPosts = ({ id, oldData, freshData }) => {
  const editedItemIndex = oldData.findIndex((p) => p.id === id);
  return [
    ...oldData.slice(0, editedItemIndex),
    freshData,
    ...oldData.slice(editedItemIndex + 1),
  ];
};
